/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventId } from "../../commons/types/EventId";
import { SpaceId } from "../../commons/types/SpaceId";
export const Execution = core.serialization.object({
    eventId: EventId,
    success: core.serialization.boolean(),
    spaceId: SpaceId.optional(),
    createdAt: core.serialization.date(),
    completedAt: core.serialization.date(),
    duration: core.serialization.number(),
    requestTime: core.serialization.number().optional(),
    requestCount: core.serialization.number().optional(),
    memoryUsage: core.serialization.number().optional(),
    topic: core.serialization.string(),
});
